import React, { useState, useEffect } from "react";
import OverView3 from "../Dashboard/Overview3";
import OverView2 from "./OverView2";
import MachineDummyStatus from "./machinedummyStatus";
import MachineManualStatus from "./manualMachineDownTime";
import { Card, CardBody, Container } from "reactstrap";
import { useLocation } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import PageGrid from "../../components/GridLayout/PageGrid";
import FieldCustomizerPanel, { useFieldCustomizer, StatCards } from "../../components/FieldCustomizer/FieldCustomizer";
import "../../components/FieldCustomizer/FieldCustomizer.css";

const KPI_FIELDS = [
  { value:"good_parts",          label:"Good Parts"     },
  { value:"bad_parts",           label:"Bad Parts"      },
  { value:"total_parts",         label:"Total Parts"    },
  { value:"total_running_hours", label:"Running Hours"  },
  { value:"stopped_time",        label:"Stopped Time"   },
  { value:"machine",             label:"Machine Name"   },
  { value:"part",                label:"Part Name"      },
  { value:"part_number",         label:"Part Number"    },
];

const KPI_DEFAULT_CARDS = [
  { id:"good",    label:"Good Parts",    field:"good_parts",          icon:"ri-checkbox-circle-line", color:"text-success", visible:true },
  { id:"bad",     label:"Bad Parts",     field:"bad_parts",           icon:"ri-close-circle-line",    color:"text-danger",  visible:true },
  { id:"total",   label:"Total Parts",   field:"total_parts",         icon:"ri-group-line",           color:"text-primary", visible:true },
  { id:"running", label:"Running Hours", field:"total_running_hours", icon:"ri-time-line",            color:"text-primary", visible:true },
  { id:"stopped", label:"Stopped Time",  field:"stopped_time",        icon:"ri-pause-circle-line",    color:"text-warning", visible:true },
];

const getCurrentShift = () => { const h=new Date().getHours(); if(h>=6&&h<14)return 1; if(h>=14&&h<22)return 2; return 3; };
const getTodayDate = () => new Date().toISOString().split("T")[0];
const isShiftDisabled = (shift, date) => {
  if(date!==new Date().toISOString().split("T")[0])return false;
  const h=new Date().getHours();
  if(shift==="1")return h<6; if(shift==="2")return h<14; if(shift==="3")return h<22&&h>=6; return false;
};

const BatchControl = () => {
  const location = useLocation();
  const machine  = location.state?.part;
  const [machines,      setMachines]      = useState([]);
  const selectedMachineId = localStorage.getItem("selectedMachineId");
  const selectedCompanyId = localStorage.getItem("companyid");
  const [selectedMachine, setSelectedMachine] = useState(machine?.machine_id || selectedMachineId);
  const [selectedDate,    setSelectedDate]    = useState(machine?.date || getTodayDate());
  const [selectedShift,   setSelectedShift]   = useState(machine?.shift || getCurrentShift());
  const [partsData,       setPartsData]       = useState({ good_parts:0, bad_parts:0, total_parts:0, total_running_hours:0, stopped_time:0, machine:"", part:"", part_number:0 });

  const kpiFC = useFieldCustomizer("batch_kpi", KPI_DEFAULT_CARDS, []);

  useEffect(() => {
    fetch(`https://api.hanoch.in/api/machines/by-company/?id=${selectedCompanyId}`)
      .then(r=>r.ok?r.json():null).then(d=>d&&setMachines(d?.data||[])).catch(console.error);
  }, []);

  const selectedMachineObject = machines.find(m=>m.id==selectedMachine);
  const isManual = selectedMachineObject?.manual ?? false;
  const selectedChildPart = selectedMachineObject?.parts;

  const fetchPLC = async (date, shift, machine) => {
    try {
      const r = await fetch(`https://api.hanoch.in/api/get-shift-data/?shift=${shift}&date=${date}&machine_id=${machine}`);
      const d = await r.json();
      setPartsData({ bad_parts:d?.bad_products||0, good_parts:d?.good_products||0, stopped_time:d?.stopped_time||0, total_parts:d?.total_count||0, total_running_hours:d?.machine_running_hours||0, machine:d?.machine_name||"", part:d?.part||"", part_number:d?.part_number||0 });
    } catch(e){ console.error(e); }
  };
  const fetchPLCManual = async (date, shift, machine) => {
    try {
      const r = await fetch(`https://api.hanoch.in/api/manual-machine-shift-data/?shift=${shift}&date=${date}&machine_id=${machine}`);
      const d = await r.json();
      setPartsData({ bad_parts:d?.bad_products||0, good_parts:d?.good_products||0, total_parts:d?.total_count||0, total_running_hours:d?.machine_running_hours||0, machine:d?.machine_name||"", part:d?.part||"", part_number:d?.part_number||0 });
    } catch(e){ console.error(e); }
  };

  useEffect(() => {
    if(selectedDate&&selectedShift&&selectedMachine)
      isManual ? fetchPLCManual(selectedDate,selectedShift,selectedMachine) : fetchPLC(selectedDate,selectedShift,selectedMachine);
  }, [selectedDate, selectedShift, selectedMachine, isManual]);

  document.title = "Batch Control | OptiMize";

  const ControlsBar = (
    <Card className="mb-0 h-100">
      <CardBody className="p-2">
        <div className="d-flex flex-wrap align-items-center gap-3 px-2 py-1">
          <div className="d-flex align-items-center gap-1">
            <label className="text-muted mb-0" style={{fontSize:13}}>Machine:</label>
            <select className="form-control form-control-sm" style={{minWidth:140}}
              value={selectedMachine||""} onChange={e=>setSelectedMachine(e.target.value)}>
              <option>Select Machine</option>
              {machines?.map((m,i)=><option key={i} value={m.id}>{m.name}</option>)}
            </select>
          </div>
          <div style={{padding:"4px 10px",border:"1px solid #dee2e6",borderRadius:6}}>
            <span style={{fontWeight:600,fontSize:14}}>{partsData?.part}</span>
          </div>
          <div className="d-flex align-items-center gap-1">
            <label className="text-muted mb-0" style={{fontSize:13}}>Shift:</label>
            <select value={selectedShift} onChange={e=>setSelectedShift(e.target.value)}
              style={{padding:"4px 8px",border:"1px solid #dee2e6",borderRadius:6,fontSize:13}}>
              <option value="">Select shift</option>
              <option value="1" disabled={isShiftDisabled("1",selectedDate)}>6-2 (Shift 1)</option>
              <option value="2" disabled={isShiftDisabled("2",selectedDate)}>2-10 (Shift 2)</option>
              <option value="3" disabled={isShiftDisabled("3",selectedDate)}>10-6 (Shift 3)</option>
            </select>
          </div>
          <div className="d-flex align-items-center gap-1">
            <label className="text-muted mb-0" style={{fontSize:13}}>Date:</label>
            <input type="date" value={selectedDate} max={getTodayDate()} onChange={e=>setSelectedDate(e.target.value)}
              style={{padding:"4px 8px",border:"1px solid #dee2e6",borderRadius:6,fontSize:13}}/>
          </div>
        </div>
      </CardBody>
    </Card>
  );

  const widgets = [
    { id:"controls", label:"Controls",        icon:"mdi mdi-cog-outline",    defaultW:12, defaultH:3, minH:2, content: ControlsBar },
    {
      id:"kpi", label:"KPI Stats", icon:"mdi mdi-view-dashboard", defaultW:12, defaultH:4, minH:3,
      customizer: (
        <FieldCustomizerPanel cards={kpiFC.cards} columns={[]} availableFields={KPI_FIELDS}
          onCardsChange={kpiFC.updateCards} onColumnsChange={()=>{}} onReset={kpiFC.resetFields}/>
      ),
      content: <StatCards cards={kpiFC.cards} data={partsData} />,
    },
    { id:"overview", label:"Production Chart", icon:"mdi mdi-chart-line",    defaultW:12, defaultH:7, minH:5,
      content: isManual
        ? <OverView2 partsDataMap={{}} selectedDate={selectedDate} selectedShift={selectedShift} selectedMachine={selectedMachine} selectedChildPart={selectedChildPart}/>
        : <OverView3 partsDataMap={{}} selectedDate={selectedDate} selectedShift={selectedShift} selectedMachine={selectedMachine} selectedChildPart={selectedChildPart}/> },
    { id:"machine", label:"Machine Status",    icon:"mdi mdi-chip",          defaultW:12, defaultH:6, minH:4,
      content: isManual
        ? <MachineManualStatus selectedDate={selectedDate} selectedShift={selectedShift} selectedMachine={selectedMachine} part={partsData?.part}/>
        : <MachineDummyStatus  selectedDate={selectedDate} selectedShift={selectedShift} selectedMachine={selectedMachine} part={partsData?.part}/> },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Batch Control" />
          <PageGrid pageKey="batch_control" widgets={widgets} />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BatchControl;
